<div>
    <div 
            class="bot-message"
            >
            <div style="display: flex; flex-direction: row;">
                <!-- <img #botImage style="margin-top: 12px;" src="../assets/images/botv2/tina-about.png" alt="" /> -->
                <div #introText class="intro_msg_text" [innerHTML]="message | safeHTML"></div>
            </div>

    <div *ngIf="false" id="video-container" style="width: 95%">
        <img src="../assets/images/botv2/into-image.png" alt="Video Thumbnail" id="thumbnail" (click)="playVideo()" />
        <div class="black-mask">

        </div>
        <button id="play-button" (click)="playVideo()">    <img src="../../../../assets/images/botv2/triangle.png" alt="play button" class="triangle_prop"/></button>
        <video controls #videoElement style="height: 110px; background-color: black;">
            <source src="../assets/videos/tina.mp4" type="video/mp4" />
            Your browser does not support the video tag.
        </video>
    </div>
</div>
</div>